import styled from 'foundations-theming/utils';
import { devices } from '../../styles/viewports.styles';
import { isCanvasTheme } from 'foundations-theming/utils';
export const StyledManageCookiesContainer = styled.div.withConfig({
  displayName: "ManageCookiesstyles__StyledManageCookiesContainer",
  componentId: "sc-4qwyf-0"
})(["font-size:17px !important;text-align:center;display:flex;justify-content:center;align-items:end;margin-top:40px;@media ", "{z-index:2147483647 !important;margin-top:0;display:flex;text-align:center;flex-direction:row;position:fixed;bottom:0;padding-bottom:30px;left:25px;}a{", ";}"], devices.desktop, props => isCanvasTheme(props.theme) && 'color: #0b8484 !important');
export const StyledSidePanelManageCookiesContainer = styled.div.withConfig({
  displayName: "ManageCookiesstyles__StyledSidePanelManageCookiesContainer",
  componentId: "sc-4qwyf-1"
})(["z-index:2147483647 !important;", " @media ", "{margin-top:0;display:block;bottom:0;left:0;}a{color:", ";}"], props => props.isMobile && `
    position: fixed;
    top: 20px;
    padding-top: 0;
    right: 20px;
  `, devices.desktop, props => props.theme.color['text-core-default']);